export interface AppVersion {
  major: number;
  minor: number;
  patch: number;
  build: 'local' | number;
}
